<!-- <div class="pwabtn" *ngIf="true">
  <div class="pwacont">
    <button mat-button (click)="installPwa()">INSTALL APPLICATION</button>
    <button mat-button (click)="installPwa()">SKIP</button>
  </div>
</div> -->

<router-outlet></router-outlet>